<template>
    <div>
        <vue-apex-charts type="pie" width="800" :options="chartOptions" :series="series"></vue-apex-charts>
    </div>
</template>
<script>
    // import initFilterModel from '@/shared/filter';
    // import {formatDate, parseDate} from '@/shared/utils';
    import VueApexCharts from 'vue-apexcharts'
    import CurrencyFilter from '@/shared/filters/currency';


    // export const
    export default {
        name: "PieChart",
        props: {
            data: Object,
            title: String,
            organizationType: String
        },
        components: {
            VueApexCharts
        },
        data() {
            return {
                series: [
                   0, 0, 0
                ],
                chartOptions: {
                    data: [
                        {contractAmount: 0, paid: 0, unpaid: 0, agentSalary: 0, agentSalaryPaid: 0},
                        {contractAmount: 0, paid: 0, unpaid: 0, agentSalary: 0, agentSalaryPaid: 0},
                        {contractAmount: 0, paid: 0, unpaid: 0, agentSalary: 0, agentSalaryPaid: 0},
                        ],
                    chart: {
                        events: {
                            // click: function(event, chartContext, config) {
                            //     // console.log("HI");
                            //     // console.log(chartContext);
                            //     // console.log(config);
                            // }
                        }
                    },
                    labels: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                    legend: {
                        show: true,
                        showForSingleSeries: false,
                        floating: false,
                        position: 'right', // whether to position legends in 1 of 4
                        // direction - top, bottom, left, right
                        horizontalAlign: 'center', // when position top/bottom, you can
                        // specify whether to align legends
                        // left, right or center
                        verticalAlign: 'middle',
                        fontSize: '12px',
                        fontFamily: undefined,
                        textAnchor: 'start',
                        offsetY: 0,
                        offsetX: 0,
                        formatter: undefined,
                        labels: {
                            colors: undefined,//['#E3FB55'],
                            useSeriesColors: false
                        },
                    },
                    theme: {
                        monochrome: {
                            enabled: true
                        }
                    },
                    title: {
                        text: undefined,
                        align: 'left',
                        margin: 10,
                        offsetX: 0,
                        offsetY: 0,
                        floating: false,
                        style: {
                            fontSize:  '12px',
                            color:  '#263238'
                        },
                    },
                    tooltip: {
                        custom: function({/*series,*/ seriesIndex /*dataPointIndex*/, w}){
                            // console.log(w);
                            // console.log(seriesIndex);
                            // console.log(dataPointIndex);
                            // console.log(w.config.data[seriesIndex]);
                            const contractAmount = CurrencyFilter(w.config.data[seriesIndex].contractAmount, '', 2, { thousandsSeparator: ' ' });
                            const paid = CurrencyFilter(w.config.data[seriesIndex].paid, '', 2, { thousandsSeparator: ' ' });
                            const unpaid = CurrencyFilter(w.config.data[seriesIndex].unpaid, '', 2, { thousandsSeparator: ' ' });

                            const agentSalary = CurrencyFilter(w.config.data[seriesIndex].agentSalary, '', 2, { thousandsSeparator: ' ' });
                            const agentSalaryPaid = CurrencyFilter(w.config.data[seriesIndex].agentSalaryPaid, '', 2, { thousandsSeparator: ' ' });
                            const str = '<br/><span style="color: #e3fb55">Жами: ' + contractAmount + '</span><br/><span style="color: orangered">Агентга: <br/>' + 'Туланган: ' + agentSalaryPaid + ', Колди: ' + agentSalary + '</span><br/> ' +
                                '<span style="color: #4CAF50">Жамиятга: <br/> Туланган: ' + paid + ', Колди: ' + unpaid + '</span>';

                            return '<div style="background-color: black; padding: 3px">' + w.globals.labels[seriesIndex] + " " + str + '</div>';
                        },
                        y: {
                            formatter: function(value) {
                                // console.log(value);
                                return value+ ' ///';
                            },
                            title: {
                                formatter: function (seriesName) {
                                    return seriesName + ''
                                }
                            }
                        }
                        // custom: function ({series, /*seriesIndex, dataPointIndex, w*/}) {
                        //     return "<div>" + series + "</div>";
                        // }
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            }
        },
        methods: {
            initList() {

            }
        },
        created() {
            this.initList();

            this.$eventBus.$on('refreshPieChart', (data) => {
                // console.log(data.data.ALL.users);
                var labels = [];
                var datas = [];
                var series =[];
                for (var i = 0; i < data.data.ALL.users.length; i++) {
                    labels.push(data.data.ALL.users[i].createUserName);
                    datas.push({
                        contractAmount: data.data.ALL.users[i].contractAmount,
                        paid: data.data.ALL.users[i].paid,
                        unpaid: data.data.ALL.users[i].unpaid,
                        agentSalary: data.data.ALL.users[i].agentSalary,
                        agentSalaryPaid: data.data.ALL.users[i].agentSalaryPaid
                    });
                    series.push(data.data.ALL.users[i].contractAmount);
                }
                this.chartOptions = {
                    labels: labels,
                    data: datas,
                    title: {text: data.title},
                };
                this.series = series;


            });
        },
        computed: {

        },
        watch: {

        }
    }
</script>
<style>

</style>

